// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"0bb2aad8","732":"b1b4794a"}[chunkId] + ".chunk.js";
};